import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {
  getCustomerPaginationUrls,
  getCustomersList,
  getCustomerTotalCount,
} from "../../../redux/Selectors/customers.selectors";
import {
  requestCustomers,
  saveSelectedCustomer,
} from "../../../redux/Actions/customers.actions";
import {generateQueryUrl} from "../../../helpers/generateQueryUrl";
import {customerListURL} from "./customerTable.constants";

export const useFetchCustomers = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = (callback) => {
    dispatch(requestCustomers("", callback));
  };

  const refetch = () => {
    dispatch(requestCustomers(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useCustomerTableData = (openAddCustomer) => {
  const dispatch = useDispatch();
  const {freshFetch} = useFetchCustomers();
  const {setPageUrl} = usePageURLContext();
  const [currentPage, setCurrentPage] = useState(1);
  const customersList = useSelector(getCustomersList);
  const CustomerTotalCount = useSelector(getCustomerTotalCount);
  const customerUrls = useSelector(getCustomerPaginationUrls);

  useEffect(() => {
    const callback = (data = {}) => {
      // open a modal to add a customer if no customers are found
      if (data.results && data.results.length == 0) {
        openAddCustomer();
      }
    };
    freshFetch(callback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (page) => {
    const url = currentPage < page ? customerUrls?.nextUrl : customerUrls?.prevUrl;
    dispatch(requestCustomers(url));
    setCurrentPage(page);
    setPageUrl(url);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  const switchCurrentCustomer = (data) => {
    dispatch(saveSelectedCustomer(data));
  };

  const handleSearch = (tokens) => {
    if (tokens?.length > 0) {
      const searchUrl = generateQueryUrl(customerListURL, tokens);
      dispatch(requestCustomers(searchUrl));
      setPageUrl(searchUrl);
      setCurrentPage(1);
    } else {
      freshFetch();
      setPageUrl("");
      setCurrentPage(1);
    }
  };

  return {
    customersList,
    CustomerTotalCount,
    handleSearch,
    paginationConfig,
    switchCurrentCustomer,
  };
};
